/**
 * Prolon Benefit Card - Expandable with View Transition API
 * Handles card expansion to span 2 columns x 2 rows in grid
 */

(function() {
  'use strict';
  
  let expandedCard = null;

  /**
   * Initialize all benefit cards
   */
  function initBenefitCards() {
    const wrappers = document.querySelectorAll('.benefit-card-wrapper');
    
    wrappers.forEach((wrapper, index) => {
      const card = wrapper.querySelector('.prolon-benefit-card');
      if (!card) return;
      
      const hasContent = card.dataset.hasContent === 'true';
      if (!hasContent) return;
      
      // Add click listener to the card
      card.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleCard(wrapper, index);
      });
    });
  }

  /**
   * Toggle card expansion with View Transition API (following HTML example pattern)
   */
  function toggleCard(wrapper, index) {
    // Use View Transition API if supported
    if (!document.startViewTransition) {
      // Fallback for browsers without View Transition API
      expand(wrapper);
      return;
    }
    
    // Use View Transitions API for smooth morph effect
    document.startViewTransition(() => {
      expand(wrapper);
    });
  }

  /**
   * Expand/collapse card (simple pattern from HTML example)
   */
  function expand(clickedWrapper) {
    const isCurrentlyExpanded = clickedWrapper.classList.contains("expanded");
    
    // Remove expanded from all cards
    document.querySelectorAll(".benefit-card-wrapper").forEach((wrapper) => {
      wrapper.classList.remove("expanded");
    });

    // Add expanded to the clicked card (if it wasn't already expanded)
    if (!isCurrentlyExpanded) {
      clickedWrapper.classList.add("expanded");
      expandedCard = clickedWrapper;
    } else {
      expandedCard = null;
    }
  }

  /**
   * Handle window resize - collapse all cards
   */
  window.addEventListener('resize', () => {
    if (expandedCard) {
      document.querySelectorAll(".benefit-card-wrapper").forEach((wrapper) => {
        wrapper.classList.remove("expanded");
      });
      expandedCard = null;
    }
  });

  /**
   * Handle escape key to close all expanded cards
   */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && expandedCard) {
      document.querySelectorAll(".benefit-card-wrapper").forEach((wrapper) => {
        wrapper.classList.remove("expanded");
      });
      expandedCard = null;
    }
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitCards);
  } else {
    initBenefitCards();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initBenefitCards);
  
})();
